// eslint-disable-next-line import/prefer-default-export
export const getTestId = (...segments) => segments
  .filter((el) => !!el)
  .join('__');
